import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";

const useTimesheet = (dbRef, timesheetId = null) => {
  const params = useParams();
  const location = useLocation();

  //Using location state here ends up showing old values of state in primaryForm
  // const [timesheet, setTimesheet] = useState({});
  const [timesheet, setTimesheet] = useState(location?.state?.timesheet ?? {});

  useEffect(() => {
    let primaryRef = doc(dbRef, timesheetId ?? params.uid);
    const unsubFromTimesheet = onSnapshot(primaryRef, (snapshot) => {
      if (snapshot.exists()) {
        setTimesheet({ ...snapshot.data() });
      }
    });

    return () => {
      unsubFromTimesheet();
    };
  }, [dbRef, params.uid, timesheetId]);

  return timesheet;
};

export default useTimesheet;
